type Props = { size?: number };

export const Logo = ({ size = 18 }: Props) => (
  <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <path
      d="M8 8 L8 56 L20 56"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M56 8 L56 56 L44 56"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <g fill="currentColor">
      <rect x="18" y="28" width="8" height="10" />
      <rect x="28" y="22" width="8" height="20" />
      <rect x="38" y="30" width="8" height="12" />
    </g>
    <g stroke="currentColor" strokeWidth="2">
      <line x1="22" y1="18" x2="22" y2="44" />
      <line x1="32" y1="14" x2="32" y2="50" />
      <line x1="42" y1="22" x2="42" y2="48" />
    </g>
  </svg>
);
